import React from "react";
import { ArrowLeft, Plus } from "../AdminIcons";

const tabs = [
  {
    key: "subCategory",
    label: "Sub Category",
  },
  {
    key: "ageGroup",
    label: "Age Group",
  },
  {
    key: "courseLevel",
    label: "Course Level",
  },
  {
    key: "category",
    label: "Category",
  },
];

const Header = ({ activeTab, setActiveTab, onAdd, onBack }) => {
  return (
    <div className="w-full max-w-[1515px] bg-[#F4F4F466] px-3 py-4 md:px-7 md:pt-5 md:pb-0">
      {/* Top section */}
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-4">
          <button
            type="button"
            aria-label="Go back"
            onClick={onBack}
            className="mt-1 shrink-0"
          >
            <ArrowLeft />
          </button>

          <div>
            <h2 className="text-xl font-bold leading-9 text-[#1F2937] sm:text-2xl">
              Manage Categories
            </h2>

            <p className="mt-1 text-sm font-normal leading-5 text-[#4B5563] sm:text-base">
              Organize courses using S.T.E.A.M framework
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onAdd}
          className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-[#923D8C] px-4 py-2.5 text-sm font-medium text-white transition hover:bg-[#7f3279] sm:px-7 sm:py-[14px] sm:text-base"
        >
          <Plus />
          <span>Add {tabs.find((tab) => tab.key === activeTab)?.label}</span>
        </button>
      </div>

      {/* Tabs */}
      <div className="mt-7 overflow-x-auto">
        <div className="flex min-w-max items-end gap-2 border-b border-[#D9D9D9]">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.key;

            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                className={`relative px-5 py-3 text-sm font-medium transition sm:px-7 sm:text-base ${
                  isActive
                    ? "text-[#923D8C]"
                    : "text-[#6B7280] hover:text-[#923D8C]"
                }`}
              >
                {tab.label}

                {isActive && (
                  <span className="absolute bottom-0 left-0 h-[3px] w-full rounded-t-full bg-[#923D8C]" />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Header;
